import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ViewInAr as ViewInArIcon } from "@mui/icons-material";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import React from "react";
export function ThreeDViewer({ modelUrl, cameraControls, ar, autoRotate, arButtonTitle = "View in your space", arFailureTitle = "AR is not tracking!", fullScreen, paddingBottom = 0, }) {
    const scriptLoaded = useModelViewerScript();
    const fileLoaded = useFileLoad(modelUrl);
    return !scriptLoaded || !fileLoaded ? (_jsx(Box, { flex: 1, display: "flex", justifyContent: "center", alignItems: "center", children: _jsx(CircularProgress, { sx: theme => ({
                color: theme.palette.mode === "dark"
                    ? theme.palette.common.white
                    : theme.palette.primary.main,
            }), color: "inherit", size: 24 }) })) : (_jsx(Box, { flex: 1, display: "flex", justifyContent: "center", alignItems: "center", height: "100%", width: "100%", position: "relative", sx: {
            "model-viewer .ar-button": {
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                bottom: fullScreen
                    ? `calc(env(safe-area-inset-bottom) + 16px + ${paddingBottom}px)`
                    : `calc(16px + ${paddingBottom}px)`,
            },
            "model-viewer .ar-failure": {
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                bottom: fullScreen
                    ? `calc(env(safe-area-inset-bottom) + 48px + ${paddingBottom}px)`
                    : `calc(48px + ${paddingBottom}px)`,
                display: "none",
            },
            'model-viewer[ar-tracking="not-tracking"] .ar-failure': {
                display: "block",
            },
        }, children: _jsxs("model-viewer", { ...(ar ? { ar: true } : undefined), ...(cameraControls ? { "camera-controls": true } : undefined), ...(autoRotate ? { "auto-rotate": true } : undefined), "quick-look-browsers": "safari chrome edge firefox", "camera-orbit": "45deg 45deg", "min-camera-orbit": "-Infinity 0deg auto", "max-camera-orbit": "Infinity 93deg auto", src: modelUrl, "shadow-intensity": "1", alt: "3D model viewer", "touch-action": "pan-y", style: {
                height: "100%",
                width: "100%",
                overflow: "hidden",
            }, children: [_jsx(Button, { slot: "ar-button", className: "ar-button", size: "medium", variant: "contained", color: "secondary", startIcon: _jsx(ViewInArIcon, {}), children: arButtonTitle }), _jsx("div", { className: "ar-failure", children: _jsx(Typography, { variant: "body2", color: "error", children: arFailureTitle }) })] }) }));
}
let script;
let isScriptLoaded = false;
const useModelViewerScript = () => {
    const [loaded, setLoaded] = React.useState(isScriptLoaded);
    React.useLayoutEffect(() => {
        if (!script) {
            script = document.createElement("script");
            const head = document.head || document.getElementsByTagName("head")[0];
            script.src =
                "https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js";
            script.async = true; // optionally
            script.type = "module";
            script.onload = () => {
                isScriptLoaded = true;
                setLoaded(true);
            };
            head.appendChild(script);
        }
    }, []);
    return loaded;
};
const useFileLoad = (fileUrl) => {
    const [loaded, setLoaded] = React.useState(false);
    React.useLayoutEffect(() => {
        if (!fileUrl)
            return;
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        fetch(fileUrl, {
            referrerPolicy: "strict-origin-when-cross-origin",
            body: null,
            method: "GET",
            mode: "cors",
            credentials: "omit",
        }).then(() => {
            setLoaded(true);
        });
    }, [fileUrl]);
    return loaded;
};
//# sourceMappingURL=ThreeDViewer.js.map